import CustomForm from "../CustomForm";
import m, {Vnode} from "mithril";
import Header from "../../ui/components/header";
import ICustomFormSettings from "../ICustomFormSettings";

export default abstract class BasePriceTest extends CustomForm {

    protected abstract readonly progress: [number, number, number][];

    protected readonly header: Header;
    private appearRight = false;

    public constructor(
        settings: ICustomFormSettings
    ) {
        super(settings);
        this.header = new Header(this.settings.form.questionary);
    }

    protected get prices(): number[] {
        return this.progress.map(p => p[0]);
    }

    protected makeAppearRight(): void {
        if (this.appearRight) {
            this.appearRight = false;
            setTimeout(() => {
                this.appearRight = true;
                m.redraw();
            }, 1);
        }
        this.appearRight = true;
    }

    rewriteFormControls(): boolean {
        return true;
    }

    protected abstract validateAndPossiblyNextForm(): void;
    protected abstract setPrice(value: number, option: number): void;
    protected abstract stepUp(option: number): void;
    protected abstract stepDown(option: number): void;
    protected abstract stepDK(option: number): void;

    protected abstract viewValue(): Vnode|null;
    protected abstract viewOptions(): Vnode|null;
    protected abstract viewQuestion(): Vnode|null;

    protected abstract getQuestion(): string;

    onbeforeupdate(): void {
        this.header.question = this.getQuestion();
    }

    protected viewLayout(content: Vnode|(Vnode|null)[]|null, controls?: Vnode|(Vnode|null)[]|null) {

        if (Array.isArray(content)) {
            content.push(m(this.validateBox))
        } else {
            content = [content, m(this.validateBox)];
        }

        return m(".customForm"+(this.appearRight?'.appear-right':''), {
            onanimationend: (e: AnimationEvent) => {
                this.appearRight = false;
                (<HTMLElement>e.currentTarget).focus();
            },
        }, [
            m(this.settings.app.header),
            m("div", {
                "class": this.settings.formHtmlClass(),
            }, [
                m(".content", {}, content),
                controls === undefined ? this.viewControls() : controls,
            ]),
        ]);
    }


    public view(): Vnode {
        return this.viewLayout(
            [
                m(this.header),
                m('.PriceTest', {}, [
                    this.viewValue(),
                    this.viewOptions(),
                ])
            ]
            , null
        );
    }
}
